import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";

export async function ResendEmailInviteAdvisorFirmMultiUser(user_email) {
    const Token = sessionStorage.getItem("Token");

    if (CheckSessionTimeout(Token)) {
        return { status: 401 };
    }

    const header = { Authorization: `Bearer ${Token}` };

    const raw = JSON.stringify({
        session_id: Token,
        user_email: user_email
    });

    const requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: header,
    };

    try {
        const response = await fetchWithTimeout(
            process.env.REACT_APP_ADVISOR_FIRM_MULTIUSER_RESEND_EMAIL_API,
            requestOptions
        );
        const message = await response.json();

        if (!response.ok) {
            return { status: response.status, error: message.error || message };
        }

        return { status: response.status, result: message.result };
    } catch (error) {
        console.error('ResendEmailInviteAdvisorFirmMultiUser error:', error);
        return { status: 0, error: error.message };
    }
}
